import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import MOCK_DATA from './billSearchController.json';

const queryBillTitleListAndAccType = (req, res, ctx) => {
  return res(ctx.json(mockResponse(MOCK_DATA['billSearchController/queryBillTitleListAndAccType'].success.default)));
};

const queryMsisdnList = (req, res, ctx) => {
  return res(ctx.json(mockResponse(MOCK_DATA['billSearchController/queryMsisdnList'].success.default)));
};

const queryBillDate = (req, res, ctx) => {
  return res(ctx.json(mockResponse(MOCK_DATA['billSearchController/queryBillDate'].success.default)));
};

const queryfeeDetailTotal = (req, res, ctx) => {
  return res(ctx.json(mockResponse(MOCK_DATA['billSearchController/queryfeeDetailTotal'].success.default)));
};

const queryCallDetail = (req, res, ctx) => {
  return res(ctx.json(mockResponse(MOCK_DATA['billSearchController/queryCallDetail'].success.default)));
};

const logBillSearchToCIE = (req, res, ctx) => {
  return res(ctx.json(mockResponse(MOCK_DATA['billSearchController/logBillSearchToCIE'].success.default)));
};

const downloadBillDetail = (req, res, ctx) => {
  return res(ctx.json(mockResponse(MOCK_DATA['billSearchController/downloadBillDetail'].success.default)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('billSearchController/queryBillTitleListAndAccType'),
    withScenario(withAuthCheck(queryBillTitleListAndAccType))
  ),
  rest.post(getApiEndpoint('billSearchController/queryMsisdnList'), withScenario(withAuthCheck(queryMsisdnList))),
  rest.post(getApiEndpoint('billSearchController/queryBillDate'), withScenario(withAuthCheck(queryBillDate))),
  rest.post(
    getApiEndpoint('billSearchController/queryfeeDetailTotal'),
    withScenario(withAuthCheck(queryfeeDetailTotal))
  ),
  rest.post(getApiEndpoint('billSearchController/queryCallDetail'), withScenario(withAuthCheck(queryCallDetail))),
  rest.post(getApiEndpoint('billSearchController/logBillSearchToCIE'), withScenario(withAuthCheck(logBillSearchToCIE))),
  rest.post(getApiEndpoint('billSearchController/downloadBillDetail'), withScenario(withAuthCheck(downloadBillDetail))),
];
